import React, {useState} from "react";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";
import NewBulkPriceChangeViewProductSelectionAutoComplete from "./auto-complete";
import Paper from "@mui/material/Paper";
import Api from "../../../../../../../../../core/services/api/api";
import BulkPriceChangeAffectedProductsTable from "../../../../../../../../components/app-specific/bulk-price-change-affected-products-table";
import {deepEqual} from "../../../../../../../../../core/services/utils/utils";
import {BulkPriceChangeEntryTypes} from "../../index";

const dataGridSaveConfig = {
    name: "BulkPriceChangeProductSelectionSectionDataGrid",
    version: 1,
}

const BulkPriceChangeProductSelectionSection = ({
                                                    excludedPartIds,
                                                    selectedItems,
                                                    selectedItemIds,
                                                    setProductSelectionState,
                                                    requestId,
                                                }) => {
    const [updating, setUpdating] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Sets the affected products of the current bulk-price-change request.
     *
     * @param forApi
     * @return {Promise<void>}
     */
    const setAffectedProducts = async (forApi) => {
        setUpdating(true);
        const response = await Api.setPartsOfBulkPriceChange(forApi);
        if (!isMounted())
            return
        setUpdating(false);
        if (response?.resultFlag) {
            setProductSelectionState(
                response.data.selections,
                response.data.affectedPart,
            );
        }
    }

    /**
     * Sets the affected products of the current bulk-price-change request by only changing the excluded partIds of the request state.
     * @param {number} excludedProductId
     */
    const setProductsViaExcludedProducts = (excludedProductId) => {
        const forApi = {
            requestId: requestId,
            tagIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.tag).map(e => ({id: e.id, title: e.value})),
            partIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.part).map(e => ({id: e.id, title: e.value})),
            categoryIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.category).map(e => ({id: e.id, title: e.value})),
            excludedParts: excludedPartIds.includes(excludedProductId)
                ? excludedPartIds.filter(e => e === excludedProductId)
                : [...excludedPartIds, excludedProductId],
        };
        setAffectedProducts(forApi).then();
    }

    /**
     * Sets the affected products of the current bulk-price-change request by changing the selected params of the request state.
     * @param {any[]} selectedOptions
     */
    const setProductsViaSelectedParams = (selectedOptions) => {
        const currentData = {
            tagIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.tag).map(e => ({id: e.id, title: e.value})),
            partIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.part).map(e => ({id: e.id, title: e.value})),
            categoryIds: selectedItems.filter(e => e.type === BulkPriceChangeEntryTypes.category).map(e => ({id: e.id, title: e.value})),
        }
        const newData = {
            tagIds: selectedOptions.filter(e => e.type === BulkPriceChangeEntryTypes.tag).map(e => ({id: e.id, title: e.value})),
            partIds: selectedOptions.filter(e => e.type === BulkPriceChangeEntryTypes.part).map(e => ({id: e.id, title: e.value})),
            categoryIds: selectedOptions.filter(e => e.type === BulkPriceChangeEntryTypes.category).map(e => ({id: e.id, title: e.value})),
        }
        if (deepEqual(currentData, newData))
            return;
        const forApi = {
            requestId: requestId,
            excludedParts: [],
            ...newData,
        };
        setAffectedProducts(forApi).then();
    }

    return (
        <>
            <div className={'d-flex flex-column w-100'}>
                <Paper className={'paper content d-flex flex-column w-100'} style={{borderRadius: '0 0 5px 5px'}}>
                    <NewBulkPriceChangeViewProductSelectionAutoComplete
                        selectedItems={selectedItems}
                        setSelectedItems={setProductsViaSelectedParams}
                        disabled={updating}
                    />
                </Paper>
                <div className={'mb-5'}/>
                {
                    !!selectedItemIds?.length &&
                    <BulkPriceChangeAffectedProductsTable
                        selectedItemIds={selectedItemIds}
                        requestId={requestId}
                        disabled={updating}
                        toggleExcludedProduct={setProductsViaExcludedProducts}
                        saveConfig={dataGridSaveConfig}
                    />
                }
            </div>
        </>
    );
}

export default BulkPriceChangeProductSelectionSection;
